var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"SlcSelectionControls-checkbox",attrs:{"color":"primary"},model:{value:(_vm.isChecked),callback:function ($$v) {_vm.isChecked=$$v},expression:"isChecked"}})}
var staticRenderFns = []

export { render, staticRenderFns }